import { useEffect, useState } from "react";
import api from "../lib/api";
import DataTable from "../components/DataTable";
import PageHeader from "../components/PageHeader";
import { Badge, statusVariant } from "../components/Badge";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { fmtBDT } from "../lib/format";
import NumberInput from "../../components/ui/NumberInput";

export default function PrePayment() {
  const [rows, setRows] = useState([]);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ agent_name: "", amount: "", note: "", status: "paid" });

  const load = async () => {
    setLoading(true);
    const [{ data: pp }, { data: ag }] = await Promise.all([api.get("/pre-payments"), api.get("/agents")]);
    setRows(pp);
    setAgents(ag);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    await api.post("/pre-payments", { ...form, amount: parseFloat(form.amount) });
    toast.success("Pre-payment recorded");
    setOpen(false);
    setForm({ agent_name: "", amount: "", note: "", status: "paid" });
    load();
  };

  return (
    <div data-testid="prepayment-page">
      <PageHeader
        title="Pre Payment"
        subtitle="Advance payments to agents"
        actions={(
          <button onClick={() => setOpen(true)} className="h-9 px-3 bg-emerald-500 hover:bg-emerald-600 text-white rounded-sm text-sm font-semibold inline-flex items-center gap-1.5" data-testid="prepayment-add-btn">
            <Plus size={14} /> New Pre Payment
          </button>
        )}
      />
      {open && (
        <form onSubmit={submit} className="bg-white border border-gray-200 rounded-sm p-5 mb-6 grid grid-cols-1 md:grid-cols-4 gap-3 fade-in-up" data-testid="prepayment-form">
          <select required value={form.agent_name} onChange={(e) => setForm({ ...form, agent_name: e.target.value })} className="h-9 px-3 border border-gray-200 rounded-sm text-sm" data-testid="prepayment-agent">
            <option value="">Select agent</option>
            {agents.map((a) => <option key={a.id} value={a.name}>{a.name}</option>)}
          </select>
          <NumberInput required placeholder="Amount" value={form.amount} onChange={(raw) => setForm({ ...form, amount: raw })} asString className="h-9 px-3 border border-gray-200 rounded-sm text-sm tabular" data-testid="prepayment-amount" />
          <input placeholder="Note" value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} className="h-9 px-3 border border-gray-200 rounded-sm text-sm" data-testid="prepayment-note" />
          <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })} className="h-9 px-3 border border-gray-200 rounded-sm text-sm">
            <option value="paid">Paid</option>
            <option value="pending">Pending</option>
          </select>
          <div className="md:col-span-4 flex justify-end gap-2">
            <button type="button" onClick={() => setOpen(false)} className="h-9 px-4 border border-gray-200 rounded-sm text-sm">Cancel</button>
            <button type="submit" className="h-9 px-4 bg-emerald-500 hover:bg-emerald-600 text-white rounded-sm text-sm font-semibold" data-testid="prepayment-submit">Save</button>
          </div>
        </form>
      )}
      <DataTable
        testId="prepayment-table"
        loading={loading}
        rows={rows}
        columns={[
          { key: "agent_name", label: "Agent" },
          { key: "amount", label: "Amount", align: "right", render: (r) => fmtBDT(r.amount) },
          { key: "note", label: "Note" },
          { key: "status", label: "Status", render: (r) => <Badge variant={statusVariant(r.status)}>{r.status}</Badge> },
          { key: "created_at", label: "Date", render: (r) => new Date(r.created_at).toLocaleString("en-GB") },
        ]}
      />
    </div>
  );
}
